@if (isRouterLoading) {
  <div class="spinner-line"></div>
}
